import styled from 'styled-components';

const ColorSpan = styled.span`
  color: ${(p) => p.color} !important;
`;

export default ColorSpan;
